import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import axios from "axios";
import {fetchAdvancedTypes, sendFixedAssetRecordToMyData} from "../../../../_apis/api";
import {setSaveEditFixedAssetRecord} from "../../../../_reducers/activitySlice";
import moment from "moment";
import {
    setEditFixedAssetRecord,
} from "../../../../_reducers/DataPanel/FixedAssets/fixedAssetsSlice";
import {
    fixedAssetRecordMyDataOptions,
    getDefaultOptionByValue,
    isEmpty
} from "../../../../_helpers/commonFunctions";
import {Button, Col, Modal, Row, Spinner} from "react-bootstrap";
import Dropdown from "../../../primer/Dropdown";
import DateBox from "../../../primer/DateBox";
import Input from "../../../common/Input";
import EditableTable from "../../../primer/Editable-Table";
import TextArea from "../../../common/TextArea";
import Alert from "react-bootstrap/Alert";
import LogTable from "../../../primer/LogTable";
import useInstallationOptions from "../../../../hooks/useInstallationOptions";
import {toast} from "react-toastify";
import {correctFixedAssetRecordRow, getAcquisitionCost, getDevaluation} from "./constants";
import {AccountingView} from "../../../primer/AccountingView/AccountingView";

const EditFixedAssetRecord = () => {
    const dispatch = useDispatch();

    const editFixedAssetRecord = useSelector((state) => state.FIXED_ASSETS.editFixedAssetRecord);
    const saveEditFixedAssetRecord = useSelector((state) => state.ACTIVITY.saveEditFixedAssetRecord);
    const advancedTypes = useSelector((state) => state.SETTINGS.settings.advancedTypes);
    const company = useSelector((state) => state.COMPANY_DATA.company);

    const installationOptions = useInstallationOptions();
    const [fixedAssetsList, setFixedAssetsList] = useState([]);

    const [loadingSendToMyData, setLoadingSendToMyData] = useState(false);
    const [showMyDataError, setShowMyDataError] = useState(false);

    const documentTypesOptions = advancedTypes.length > 0 ?
        advancedTypes.filter((el) => el.section === "Fixed Asset Records").map((o) => {
            return {
                value: o._id,
                label: o.name,
            }
        })
        : [];

    const preNumberGreekOptions = (advancedTypes.advancedTypes?.length > 0 && editFixedAssetRecord.installation && editFixedAssetRecord.documentType) ?
        advancedTypes.find((el) => el._id === editFixedAssetRecord.documentType)?.documentNumbering?.map((docNum) => {
            if (docNum.installationMasterId === editFixedAssetRecord.installation) {
                return {
                    value: docNum.preNumber,
                    label: docNum.preNumber === "noprefix" ? "Κενή" : docNum.preNumber,
                    number: docNum.number,
                }
            }
            return null;
        }).filter(Boolean)
        : [];

    const calculationBy = editFixedAssetRecord?.documentType ?
        (advancedTypes.find((el) => el._id === editFixedAssetRecord.documentType)?.depreciationCalculation || "daily")
        :
        "daily";

    const [incrKey, setIncrKey] = useState(0);

    useEffect(() => {
        setIncrKey(incrKey + 1);
    }, [editFixedAssetRecord.fixedAssets, fixedAssetsList])

    const loadFixedAssetsListData = (keyword, setData) => {
        const reqData = {
            company: company.id,
            documentId: editFixedAssetRecord.documentType || "",
            installation: editFixedAssetRecord.installation,
        }
        if (keyword) reqData.keyword = keyword;
        axios.get(`${process.env.REACT_APP_API_URL2}/fixedassets/list-fixed-assets`, {
            headers: {'Content-Type': 'application/json'},
            params: reqData,
        }).then((res) => {
            if (res.data.status === "200") {
                if (res.data.data.length > 0) {
                    res.data.data.forEach((asset) => {
                        asset.finalAcquisitionCost = getAcquisitionCost(asset);
                    })
                }
                setData(res.data.data);
            }
        }).catch((err) => {
            setData([]);
            console.log(err);
        })
    }

    const tableColumns  = [
        {
            name: "Αρ.",
            field: "no",
            editable: false,
            width: "5%",
        },
        {
            name: "Κωδικός Συστήματος / Χειροκίνητος Κωδικός",
            field: "mixedCode",
            editable: false,
            width: "15%",
        },
        {
            name: "Όνομα Παγίου",
            field: "name",
            editable: true,
            width: "35%",
            inputType: {
                config: {
                    onChangeSearchCell: (_, keyword, setData) => loadFixedAssetsListData(keyword, setData),
                    excludeColumns: [],
                    columns: [
                        {label: "Όνομα", name: "name"},
                        {label: "Κόστος Κτήσης", name: "finalAcquisitionCost"},
                        {label: "Αποσβεσμένο Ποσό", name: "accumulatedDepreciation"},
                    ],
                    data: fixedAssetsList,
                    deleteEnable: false,
                    searchTableEnable: false,
                    showTableOptionOnSelect: true,
                    placeholder: "Επιλέξτε πάγιο"
                },
                type: 'advanced-combobox',
            }
        },
        {
            name: "Κόστος Κτήσης",
            field: 'acquisitionCost',
            editable: true,
            disabled: true,
            width: "10%",
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    maxLength: 10,
                    allowNegative: true,
                    notAllowed: true,
                }
            }
        },
        {
            name: "Αποσβεσμένο Ποσό",
            field: 'accumulatedDepreciation',
            editable: true,
            disabled: true,
            width: "10%",
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    maxLength: 10,
                    allowNegative: true,
                    notAllowed: true,
                }
            }
        },
        {
            name: "Ποσό απόσβεσης",
            field: 'amount',
            editable: true,
            width: "10%",
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    maxLength: 10,
                }
            }
        },
        {
            name: "Νέο υπόλοιπο",
            field: "balance",
            editable: true,
            disabled: true,
            width: "10%",
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    maxLength: 10,
                    allowNegative: true,
                    notAllowed: true,
                }
            }
        },
    ];

    useEffect(() => {
        dispatch(fetchAdvancedTypes({company: company.id}));
    }, [])

    useEffect(() => {
        if (editFixedAssetRecord.documentType) {
            loadFixedAssetsListData(null, setFixedAssetsList);
        }
    }, [editFixedAssetRecord.documentType, editFixedAssetRecord.installation]);

    const handleOnChange = (e, type, name) => {
        if (!saveEditFixedAssetRecord) dispatch(setSaveEditFixedAssetRecord(true));

        const prepChange = {};

        if (type === "dd") {
            prepChange[name] = e.value;
        } else if (type === "input") {
            prepChange[name] = e.target.value;
        } else if (type === "datebox") {
            if (moment(e).isValid()) {
                prepChange[name] = moment(e).hour(10);
            } else {
                prepChange[name] = "";
            }
        }

        dispatch(setEditFixedAssetRecord({...editFixedAssetRecord, ...prepChange}));
    }

    const tableFunctions = {
        insert: (e, data) => {
            if (e.key === "Enter") return;
            if (!saveEditFixedAssetRecord) dispatch(setSaveEditFixedAssetRecord(true));

            if (data.field === "name") {
                const alreadyExisting = editFixedAssetRecord.fixedAssets.some((el) => el._id === e.row._id);
                if (alreadyExisting) {
                    setIncrKey(incrKey + 1);
                    return toast.error("Το πάγιο αυτό έχει ήδη επιλεχθεί.");
                }
                const cloneFixedAssets = structuredClone(editFixedAssetRecord.fixedAssets);
                const md = e.row?.mydata;
                let prepObj = {
                    _id: e.row._id,
                    no: String(cloneFixedAssets.length + 1),
                    name: e.row.name,
                    mixedCode: e.row.systemCode + (e.row.manualCode ? ` / ${e.row.manualCode}` : ""),
                    acquisitionCost: getAcquisitionCost(e.row),
                    accumulatedDepreciation: e.row.accumulatedDepreciation,
                    amount: getDevaluation(e.row, moment(editFixedAssetRecord.dateTo).toDate(), calculationBy).devaluationAfterBalance,
                    balance: 0,
                    classificationCategory: md ? md[0].category : "",
                    classificationType: md ? md[0].type : "",
                }
                prepObj = correctFixedAssetRecordRow(prepObj);

                cloneFixedAssets.push(prepObj);
                dispatch(setEditFixedAssetRecord({...editFixedAssetRecord, fixedAssets: cloneFixedAssets}));
            }
        },
        update: (data, id, rowIndex, e) => {
            if (e.key === "Enter") return;
            if (!saveEditFixedAssetRecord) dispatch(setSaveEditFixedAssetRecord(true));

            const cloneFixedAssets = structuredClone(editFixedAssetRecord.fixedAssets);
            const findMatching = cloneFixedAssets[rowIndex];
            if (e?.row) { // Its advanced combo box
                const alreadyExisting = editFixedAssetRecord.fixedAssets.some((el, idx) => el._id === e.row._id && rowIndex !== idx);
                if (alreadyExisting) {
                    setIncrKey(incrKey + 1);
                    return toast.error("Το πάγιο αυτό έχει ήδη επιλεχθεί.");
                }
                findMatching._id = e.row._id;
                findMatching.name = e.row.name;
                findMatching.mixedCode = e.row.systemCode + (e.row.manualCode ? ` / ${e.row.manualCode}` : "");
                findMatching.acquisitionCost = getAcquisitionCost(e.row);
                findMatching.accumulatedDepreciation = e.row.accumulatedDepreciation;
                findMatching.amount = getDevaluation(e.row, moment(editFixedAssetRecord.dateTo).toDate(), calculationBy).devaluationAfterBalance;
                const md = findMatching?.mydata;
                if (md) {
                    findMatching.classificationCategory = md[0].category;
                    findMatching.classificationType = md[0].type;
                }
            } else {
                if (!isEmpty(data.amount)) {
                    findMatching.amount = +Number(data.amount).toFixed(2);
                    findMatching.balance = +Number(findMatching.acquisitionCost - findMatching.accumulatedDepreciation - findMatching.amount).toFixed(2);
                }
            }
            dispatch(setEditFixedAssetRecord({
                ...editFixedAssetRecord,
                fixedAssets: cloneFixedAssets,
            }));
        },
        selected: () => {},
        delete: (id, rowIndex) => {
            if (!saveEditFixedAssetRecord) dispatch(setSaveEditFixedAssetRecord(true));

            const cloneFixedAssets = structuredClone(editFixedAssetRecord.fixedAssets);
            cloneFixedAssets.splice(rowIndex, 1);
            cloneFixedAssets.forEach((row, idx) => {
                row.no = String(idx + 1);
            })
            dispatch(setEditFixedAssetRecord({
                ...editFixedAssetRecord,
                fixedAssets: cloneFixedAssets,
            }))
        },
    }

    const handleSendToMyData = () => {
        dispatch(sendFixedAssetRecordToMyData({
            recordId: editFixedAssetRecord._id,
            company: company.id,
        }, setLoadingSendToMyData));
    }

    const disabledFields = editFixedAssetRecord.myDataStatus === "sent";

    return (
        <React.Fragment>
            <AccountingView document={editFixedAssetRecord} />
            {editFixedAssetRecord.myDataStatus === "sent" && (
                <Alert variant={"secondary"}>
                    Μερικά πεδία δεν είναι επεξεργάσιμα διότι η απόσβεση έχει σταλεί το MyData.<br/>
                    <strong>MARK:</strong> {editFixedAssetRecord.mark}<br/>
                    <strong>UID:</strong> {editFixedAssetRecord.uid}<br/>
                </Alert>
            )}
            <Row>
                <Col md={3}>
                    <Dropdown
                        name={"documentType"}
                        label={"Τύπος Παραστατικού"}
                        key={editFixedAssetRecord.documentType}
                        defaultValue={documentTypesOptions.find((el) => el.value === editFixedAssetRecord.documentType)}
                        options={documentTypesOptions}
                        disabled={true}
                    />
                </Col>
                <Col md={9} className={"d-flex justify-content-end"}>
                    <div style={{marginTop: "23px"}} className={"mr-2"}>
                        {(!isEmpty(editFixedAssetRecord.myDataError) && editFixedAssetRecord.myDataStatus !== "sent") && (
                            <Button className={"mr-2"} onClick={() => setShowMyDataError(true)}>Προβολή σφάλματος MyData</Button>
                        )}
                        <Button onClick={() => handleSendToMyData()} disabled={loadingSendToMyData || editFixedAssetRecord.myDataStatus === "sent"}>
                            Αποστολή στο MyData {loadingSendToMyData && (
                                <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />
                            )}
                        </Button>
                    </div>
                    <div style={{maxWidth: "250px"}}>
                        <Dropdown
                            label={"Κατάσταση MyData"}
                            options={fixedAssetRecordMyDataOptions()}
                            key={editFixedAssetRecord.myDataStatus}
                            defaultValue={getDefaultOptionByValue(fixedAssetRecordMyDataOptions(), editFixedAssetRecord.myDataStatus, 'value', 'label', 'value')}
                            name={"myDataStatus"}
                            disabled={true}
                        />
                    </div>
                </Col>
            </Row>
            <Row className={"mt-2"}>
                <Col md={3}>
                    <Dropdown
                        name={"installation"}
                        label={"Εγκατάσταση"}
                        key={editFixedAssetRecord.installation}
                        defaultValue={installationOptions.find((el) => el.value === editFixedAssetRecord.installation)}
                        required={true}
                        options={installationOptions}
                        disabled={true}
                    />
                </Col>
                <Col md={2}>
                    <DateBox
                        label={"Ημερομηνία εγγραφής"}
                        name={"date"}
                        required={true}
                        selected={moment(editFixedAssetRecord.date).isValid() ? moment(editFixedAssetRecord.date).toDate() : null}
                        disabled={disabledFields}
                        onChange={(e) => handleOnChange(e, "datebox", "date")}
                    />
                </Col>
                <Col md={2}>
                    <DateBox
                        label={"Απόσβεση έως"}
                        name={"dateTo"}
                        required={true}
                        selected={moment(editFixedAssetRecord.dateTo).isValid() ? moment(editFixedAssetRecord.dateTo).toDate() : null}
                        disabled={disabledFields}
                        onChange={(e) => handleOnChange(e, "datebox", "dateTo")}
                    />
                </Col>
                <Col md={2}>
                    <Dropdown
                        label={"Σειρά"}
                        name="preNumber"
                        key={editFixedAssetRecord.preNumber}
                        defaultValue={preNumberGreekOptions.find((el) => el.value === editFixedAssetRecord.preNumber)}
                        options={preNumberGreekOptions}
                        required={true}
                        disabled={true}
                    />
                </Col>
                <Col md={2}>
                    <Input
                        label={"Αρίθμηση"}
                        charLimit={10}
                        name="number"
                        value={editFixedAssetRecord.number}
                        disabled={true}
                    />
                </Col>
            </Row>
            <Row className={"mt-2"}>
                <Col md={12}>
                    <Input
                        name={"reason"}
                        label={"Αιτιολογία"}
                        value={editFixedAssetRecord.reason}
                        autoComplete={"off"}
                        onChange={(e) => handleOnChange(e, "input", "reason")}
                    />
                </Col>
            </Row>
            <Row className={"mt-2"} style={{pointerEvents: disabledFields ? "none" : ""}}>
                <Col md={12}>
                    <div className={"text-muted"}><i>Πίνακας παγίων</i></div>
                    <EditableTable
                        tableName={"Fixed Asset Record Assets"}
                        key={"Fixed Asset Record Assets" + incrKey}
                        allowActions={true}
                        actionButtons={{
                            print: false,
                            delete: true,
                            export: false,
                            edit: true,
                        }}
                        onUpdate={tableFunctions}
                        allowInsertRow={true}
                        columns={tableColumns}
                        enableNewRowCheckbox={true}
                        data={editFixedAssetRecord.fixedAssets}
                    />
                </Col>
            </Row>
            <Row className={"mt-2"}>
                <Col md={12}>
                    <TextArea
                        rows={"4"}
                        label={"Σημειώσεις"}
                        name={"notes"}
                        limit={"1000"}
                        value={editFixedAssetRecord.notes}
                        onChange={(e) => handleOnChange(e, "input", "notes")}
                    />
                </Col>
            </Row>

            <Modal show={showMyDataError} onHide={() => setShowMyDataError(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Σφάλμα MyData</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {editFixedAssetRecord.myDataError}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShowMyDataError(false)}>
                        Κλείσιμο
                    </Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    )
}

export const EditFixedAssetRecordLog = () => {
    const editFixedAssetRecord = useSelector((state) => state.FIXED_ASSETS.editFixedAssetRecord);

    return (
        <React.Fragment>
            <div className="text-muted mb-2"><i>Ιστορικό απόσβεσης</i></div>
            <LogTable itemId={editFixedAssetRecord._id}/>
        </React.Fragment>
    )
}

export default EditFixedAssetRecord;
